
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/fulfillment",
      function () {
        return require("private-next-pages/partners/fulfillment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/fulfillment"])
      });
    }
  